// Pedalokos — estrutura editorial do mega menu desktop v4.
// Altera apenas a apresentação deste tema e preserva os hrefs originais.
(() => {
  const normalizeText = (value = '') =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const normalizeKey = (value = '') =>
    normalizeText(value)
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');

  const comparePtBr = (left, right) =>
    left.localeCompare(right, 'pt-BR', {
      sensitivity: 'base',
      numeric: true,
      ignorePunctuation: true,
    });

  const ensureStyles = () => {
    document.getElementById('pdl-mega-menu-layout-v2')?.remove();
    document.getElementById('pdl-mega-menu-structure-v3')?.remove();
    if (document.getElementById('pdl-mega-menu-structure-v4')) return;

    const style = document.createElement('style');
    style.id = 'pdl-mega-menu-structure-v4';
    style.textContent = `
      @media screen and (min-width: 1000px) {
        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--structured > .pdl-dh__submenu-grid {
          display: grid !important;
          column-count: auto !important;
          column-gap: 34px !important;
          gap: 28px 34px !important;
          align-items: start !important;
        }

        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--cols-4 > .pdl-dh__submenu-grid {
          grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
        }

        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--cols-5 > .pdl-dh__submenu-grid {
          grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
        }

        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--cols-6 > .pdl-dh__submenu-grid {
          grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
        }

        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--structured > .pdl-dh__submenu-grid > .pdl-dh__submenu-column {
          display: block !important;
          width: auto !important;
          min-width: 0 !important;
          margin: 0 !important;
          break-inside: auto !important;
          page-break-inside: auto !important;
          vertical-align: top !important;
        }

        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--structured .pdl-dh__submenu-links > a {
          display: block !important;
          margin: 0 !important;
          color: #555 !important;
          font-family: inherit !important;
          font-size: 13px !important;
          font-weight: 400 !important;
          line-height: 1.3 !important;
          letter-spacing: normal !important;
          text-transform: none !important;
        }

        body .pdl-dh .pdl-dh__submenu .pdl-dh__submenu-group-title {
          display: inline-block !important;
          margin-bottom: 9px !important;
          color: #111 !important;
          font-family: var(--font-subheading--family, sans-serif) !important;
          font-size: 14px !important;
          font-weight: 800 !important;
          line-height: 1.25 !important;
          text-transform: uppercase !important;
          cursor: default !important;
        }

        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--components-flow > .pdl-dh__submenu-grid {
          display: block !important;
          column-count: 6 !important;
          column-gap: 34px !important;
        }

        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--components-flow > .pdl-dh__submenu-grid > .pdl-dh__submenu-column {
          display: inline-block !important;
          width: 100% !important;
          margin: 0 0 22px !important;
          break-inside: avoid !important;
          break-inside: avoid-column !important;
          page-break-inside: avoid !important;
          vertical-align: top !important;
        }
      }

      @media screen and (min-width: 1251px) and (max-width: 1499px) {
        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--components-flow > .pdl-dh__submenu-grid {
          column-count: 5 !important;
        }
      }

      @media screen and (min-width: 1000px) and (max-width: 1250px) {
        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--structured > .pdl-dh__submenu-grid {
          grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
          gap: 24px 28px !important;
        }

        body .pdl-dh .pdl-dh__submenu.pdl-dh__submenu--components-flow > .pdl-dh__submenu-grid {
          column-count: 4 !important;
          column-gap: 28px !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getTopMenuLabel = (item) => {
    const node = item.querySelector(':scope > .pdl-dh__menu-trigger span, :scope > .pdl-dh__menu-link');
    return normalizeText(node?.textContent || '');
  };

  const getSubmenuText = (submenu) =>
    normalizeText(
      Array.from(submenu.querySelectorAll('.pdl-dh__submenu-title, .pdl-dh__submenu-links a'))
        .map((node) => node.textContent || '')
        .join(' | ')
    );

  const detectMenuType = (item, submenu) => {
    const label = getTopMenuLabel(item);
    const content = getSubmenuText(submenu);

    if (
      label.includes('ferrament') ||
      (content.includes('bombas de ar') && (content.includes('graxas') || content.includes('lubrificantes')))
    ) return 'tools';

    if (
      label.includes('vestuario') ||
      (content.includes('bermudas') && content.includes('capacetes') && content.includes('sapatilhas'))
    ) return 'clothing';

    if (
      label.includes('componente') ||
      (content.includes('abracadeiras') && content.includes('cubos') && content.includes('freios'))
    ) return 'components';

    if (
      label.includes('acessor') ||
      (content.includes('bagageiros') && (content.includes('caramanholas') || content.includes('transbikes')))
    ) return 'accessories';

    return '';
  };

  const addToRegistry = (map, label, anchor) => {
    if (!anchor) return;
    const key = normalizeKey(label);
    if (!key) return;
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(anchor);
  };

  const buildLinkRegistry = (submenu) => {
    const grid = submenu?.querySelector(':scope > .pdl-dh__submenu-grid');
    const registry = {
      leaf: new Map(),
      standalone: new Map(),
      title: new Map(),
      usableOrder: [],
    };

    if (!grid) return registry;

    Array.from(grid.children).forEach((column) => {
      if (!column.classList.contains('pdl-dh__submenu-column')) return;

      const titleAnchor = column.querySelector(':scope > .pdl-dh__submenu-title');
      const childAnchors = Array.from(column.querySelectorAll(':scope > .pdl-dh__submenu-links > a[href]'));

      if (titleAnchor) {
        addToRegistry(registry.title, titleAnchor.textContent, titleAnchor);
        if (!childAnchors.length) {
          addToRegistry(registry.standalone, titleAnchor.textContent, titleAnchor);
          registry.usableOrder.push(titleAnchor);
        }
      }

      childAnchors.forEach((anchor) => {
        addToRegistry(registry.leaf, anchor.textContent, anchor);
        registry.usableOrder.push(anchor);
      });
    });

    return registry;
  };

  const takeLink = (registry, label, usedAnchors) => {
    const key = normalizeKey(label);
    const sources = [registry.leaf, registry.standalone, registry.title];

    for (const source of sources) {
      const candidates = source.get(key) || [];
      const available = candidates.find((anchor) => !usedAnchors.has(anchor));
      if (!available) continue;
      usedAnchors.add(available);
      return available;
    }

    return null;
  };

  const prepareLeafAnchor = (anchor) => {
    anchor.classList.remove('pdl-dh__submenu-title');
    anchor.removeAttribute('aria-current');
    return anchor;
  };

  const clearLayoutClasses = (submenu) => {
    submenu.classList.remove(
      'pdl-dh__submenu--horizontal-grid',
      'pdl-dh__submenu--structured',
      'pdl-dh__submenu--components-flow',
      'pdl-dh__submenu--cols-4',
      'pdl-dh__submenu--cols-5',
      'pdl-dh__submenu--cols-6'
    );
  };

  const renderSemanticGroups = (submenu, groups, columns) => {
    const grid = submenu?.querySelector(':scope > .pdl-dh__submenu-grid');
    if (!grid) return false;

    const registry = buildLinkRegistry(submenu);
    const usedAnchors = new Set();
    const groupColumns = [];
    const fragment = document.createDocumentFragment();

    groups.forEach((group) => {
      const column = document.createElement('div');
      column.className = 'pdl-dh__submenu-column';

      const heading = document.createElement('div');
      heading.className = 'pdl-dh__submenu-title pdl-dh__submenu-group-title';
      heading.textContent = group.title;
      column.appendChild(heading);

      const links = document.createElement('div');
      links.className = 'pdl-dh__submenu-links';

      group.items.forEach((label) => {
        const anchor = takeLink(registry, label, usedAnchors);
        if (anchor) links.appendChild(prepareLeafAnchor(anchor));
      });

      column.appendChild(links);
      groupColumns.push({ column, links });
      fragment.appendChild(column);
    });

    const fallbackLinks = groupColumns[groupColumns.length - 1]?.links;
    registry.usableOrder.forEach((anchor) => {
      if (!usedAnchors.has(anchor) && fallbackLinks) {
        usedAnchors.add(anchor);
        fallbackLinks.appendChild(prepareLeafAnchor(anchor));
      }
    });

    grid.replaceChildren(fragment);
    clearLayoutClasses(submenu);
    submenu.classList.add('pdl-dh__submenu--structured', `pdl-dh__submenu--cols-${columns}`);
    return true;
  };

  const reorderColumns = (submenu, desiredOrder) => {
    const grid = submenu?.querySelector(':scope > .pdl-dh__submenu-grid');
    if (!grid) return false;

    const desiredRank = new Map(desiredOrder.map((label, index) => [normalizeKey(label), index]));
    const columns = Array.from(grid.children).filter((child) =>
      child.classList.contains('pdl-dh__submenu-column')
    );
    const originalRank = new Map(columns.map((column, index) => [column, index]));

    columns.sort((left, right) => {
      const leftLabel = normalizeKey(left.querySelector(':scope > .pdl-dh__submenu-title')?.textContent || '');
      const rightLabel = normalizeKey(right.querySelector(':scope > .pdl-dh__submenu-title')?.textContent || '');
      const leftRank = desiredRank.has(leftLabel) ? desiredRank.get(leftLabel) : Number.MAX_SAFE_INTEGER;
      const rightRank = desiredRank.has(rightLabel) ? desiredRank.get(rightLabel) : Number.MAX_SAFE_INTEGER;

      if (leftRank !== rightRank) return leftRank - rightRank;
      return originalRank.get(left) - originalRank.get(right);
    });

    const fragment = document.createDocumentFragment();
    columns.forEach((column) => fragment.appendChild(column));
    grid.appendChild(fragment);
    return true;
  };

  const reorderChildLinks = (column, desiredOrder = []) => {
    const linksContainer = column?.querySelector(':scope > .pdl-dh__submenu-links');
    if (!linksContainer) return;

    const anchors = Array.from(linksContainer.querySelectorAll(':scope > a[href]'));
    const desiredRank = new Map(desiredOrder.map((label, index) => [normalizeKey(label), index]));
    const originalRank = new Map(anchors.map((anchor, index) => [anchor, index]));

    anchors.sort((left, right) => {
      const leftKey = normalizeKey(left.textContent || '');
      const rightKey = normalizeKey(right.textContent || '');
      const leftRank = desiredRank.has(leftKey) ? desiredRank.get(leftKey) : Number.MAX_SAFE_INTEGER;
      const rightRank = desiredRank.has(rightKey) ? desiredRank.get(rightKey) : Number.MAX_SAFE_INTEGER;

      if (leftRank !== rightRank) return leftRank - rightRank;
      if (leftRank === Number.MAX_SAFE_INTEGER) {
        return comparePtBr(left.textContent.trim(), right.textContent.trim());
      }
      return originalRank.get(left) - originalRank.get(right);
    });

    const fragment = document.createDocumentFragment();
    anchors.forEach((anchor) => fragment.appendChild(anchor));
    linksContainer.appendChild(fragment);
  };

  const structureClothing = (submenu) => {
    const parentOrder = [
      'Vestuário',
      'Performance',
      'Proteção',
      'Calçados',
      'Acessórios de Vestuário',
    ];

    const childOrders = {
      vestuario: [
        'Bermudas',
        'Calças',
        'Camisetas e Camisas de Manga Curta',
        'Camisetas e Camisas de Manga Longa',
        'Conjuntos de Vestuário',
        'Jaquetas e Blusas',
      ],
      performance: [
        'Bretelles',
        'Macaquinhos',
        'Manguitos e Pernitos',
        'Meias',
        'Segundas Peles',
      ],
      protecao: [
        'Capacetes',
        'Capacetes Full Face',
        'Joelheiras e Cotoveleiras',
        'Luvas Abertas',
        'Luvas Fechadas',
        'Óculos',
        'Óculos Acessórios',
      ],
      calcados: ['Sapatilhas', 'Tacos / Taquinhos'],
      'acessorios de vestuario': ['Capas de Chuva', 'Toucas e Bandanas'],
    };

    if (!reorderColumns(submenu, parentOrder)) return false;

    submenu.querySelectorAll(':scope > .pdl-dh__submenu-grid > .pdl-dh__submenu-column').forEach((column) => {
      const key = normalizeKey(column.querySelector(':scope > .pdl-dh__submenu-title')?.textContent || '');
      if (childOrders[key]) reorderChildLinks(column, childOrders[key]);
    });

    clearLayoutClasses(submenu);
    submenu.classList.add('pdl-dh__submenu--structured', 'pdl-dh__submenu--cols-5');
    return true;
  };

  const structureComponents = (submenu) => {
    const componentOrder = [
      'Abraçadeiras',
      'Alavancas',
      'Aros',
      'Blocagens',
      'Caixas de Centro',
      'Caixas de Direção',
      'Canotes',
      'Catracas e Cassetes',
      'Coroas',
      'Correntes',
      'Cubos',
      'Câmaras',
      'Câmbios',
      'Freios',
      'Gancheiras',
      'Garfos e Suspensões de Bicicletas',
      'Grupos',
      'Guidões',
      'Kits',
      'Manoplas, Punhos e Fitas',
      'Mesas e Avanços',
      'Outros Componentes',
      'Pedais',
      'Pedivela',
      'Pneus',
      'Quadros',
      'Raios',
      'Rodas',
      'Selins',
    ];

    if (!reorderColumns(submenu, componentOrder)) return false;

    submenu.querySelectorAll(':scope > .pdl-dh__submenu-grid > .pdl-dh__submenu-column').forEach((column) => {
      const linksContainer = column.querySelector(':scope > .pdl-dh__submenu-links');
      if (!linksContainer) return;

      const anchors = Array.from(linksContainer.querySelectorAll(':scope > a[href]'));
      anchors.sort((left, right) => comparePtBr(left.textContent.trim(), right.textContent.trim()));

      const fragment = document.createDocumentFragment();
      anchors.forEach((anchor) => fragment.appendChild(anchor));
      linksContainer.appendChild(fragment);
    });

    clearLayoutClasses(submenu);
    submenu.classList.add('pdl-dh__submenu--components-flow');
    return true;
  };

  const toolsGroups = [
    {
      title: 'Bombas e Calibragem',
      items: ['Bombas de Ar', 'Outras Peças para Bombas de AR', 'Refis de CO2'],
    },
    {
      title: 'Limpeza e Lubrificação',
      items: [
        'Desengraxastes',
        'Graxas',
        'Kits de Limpeza',
        'Lubrificantes para Bicicleta',
        'Outras peças para Lubrificantes',
        'Óleos para Suspensão',
      ],
    },
    {
      title: 'Reparos',
      items: ['Canivetes'],
    },
    {
      title: 'Outros',
      items: [
        'Chaves',
        'Extratores',
        'Outras peças para Ferramentas',
        'Suporte para Ferramentas',
        'Suportes de Parede para Bicicleta',
      ],
    },
  ];

  const accessoriesGroups = [
    {
      title: 'Acessórios Gerais',
      items: [
        'Bagageiros',
        'Bar Ends',
        'Bolsas e Mochilas',
        'Buzinas',
        'Cadeados',
        'Cadeirinhas',
        'Cestos',
        'Outros Acessórios',
      ],
    },
    {
      title: 'Uso e Conforto',
      items: [
        'Descansos e Pezinhos',
        'Espelhos',
        'Paralamas',
        'Pedanas e Apoios',
        'Relógios',
        'Rodas Laterais',
        'Suplementos',
      ],
    },
    {
      title: 'Energia e Iluminação',
      items: ['Baterias', 'Acessórios para Baterias', 'Ciclocomputadores', 'Vista Lights', 'Faróis'],
    },
    {
      title: 'Hidratação',
      items: ['Caramanholas', 'Suportes Caramanhola'],
    },
    {
      title: 'Treino',
      items: ['Rolos de Treinamento', 'Outras Peças para Rolos de Treinamento', 'Suportes de Roda'],
    },
  ];

  const structureSubmenu = (item, submenu) => {
    const type = detectMenuType(item, submenu);
    if (!type) return;
    if (submenu.dataset.pdlMegaStructureV4 === type) return;

    let success = false;

    if (type === 'tools') success = renderSemanticGroups(submenu, toolsGroups, 4);
    if (type === 'clothing') success = structureClothing(submenu);
    if (type === 'components') success = structureComponents(submenu);
    if (type === 'accessories') success = renderSemanticGroups(submenu, accessoriesGroups, 5);

    if (success) submenu.dataset.pdlMegaStructureV4 = type;
  };

  const applyStructure = (root) => {
    const menuItems = Array.from(root.querySelectorAll('.pdl-dh__menu > .pdl-dh__menu-item'));

    menuItems.forEach((item) => {
      const submenu = item.querySelector(':scope > .pdl-dh__submenu');
      if (!submenu || submenu.classList.contains('pdl-dh__submenu--solutions')) return;
      structureSubmenu(item, submenu);
    });
  };

  const initialize = () => {
    ensureStyles();
    document.querySelectorAll('[data-pdl-desktop-header]').forEach(applyStructure);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  const headerGroup = document.getElementById('header-group');
  if (headerGroup) {
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        initialize();
      });
    }).observe(headerGroup, { childList: true, subtree: true });
  }
})();
